import {Storage} from "@ionic/storage-angular";
import {Injectable} from "@angular/core";

@Injectable({
  providedIn: 'root'
})
export abstract class CoreStorageBaseService<T> {
  protected abstract key: string;

  protected constructor(
    private storage: Storage
  ) {
  }

  async set(data: unknown): Promise<void> {
    await this.storage.set(this.key, data);
  }

  async setCustomKey(key: string, data: unknown): Promise<void> {
    await this.storage.set(key, data);
  }

  async remove(): Promise<void> {
    await this.storage.remove(this.key);
  }

  get(): Promise<T> {
    return this.storage.get(this.key);
  }

  getCustomKey(key: string): Promise<T> {
    return this.storage.get(key);
  }

  async merge(newData: T): Promise<void> {
    const currentData = await this.get();
    const updatedData = { ...(currentData ?? {}), ...(newData ?? {}) };
    await this.set(updatedData);
  }

  async clear(): Promise<void> {
    await this.storage.clear();
  }
}
